export const LAYOUT_VIEW_RENDERER_PAGE_SIZE = 10;
